import React from 'react';
import jcfront from '../media/jcfront.jpg';
import idoatjane from '../media/idoatjane.jpg';
import tsirsjane from '../media/tsirsjane.jpg';
import tsirsjanebookshop from '../media/tsirsjanebookshop.jpg';

import './AboutMe.css';
import {aboutMeContent} from '../content/aboutme/aboutMeContent';

const imageMap = {
  idoatjane,
  tsirsjane,
  tsirsjanebookshop,
};

function AboutMe() {
  const c = aboutMeContent;

  return (
    <div className='Aboutme'>
      <div className='aboutmepage pb-5'>
        <h1 className='text-center'>{c.pageTitle}</h1>

        <div className='row m-4'>
          {c.topImages.map((img) => (
            <div
              className='col-4 order-1 pt-3 pt-lg-0'
              key={img.key}>
              <img
                src={imageMap[img.key]}
                alt={img.alt}
                className='introimage'
              />
            </div>
          ))}
        </div>

        <img
          src={jcfront}
          alt={c.profileMobileAlt}
          className='profile d-block d-md-none'
        />

        <div className='m-4'>
          <img
            src={jcfront}
            alt={c.profileDesktopAlt}
            className='float-start img-fluid profile d-none d-md-block m-md-3 me-3 me-md-4 me-lg-5'
          />

          <p className='p-md-3 text-center text-md-start aboutmetext'>
            {c.introBlurb}
          </p>
        </div>

        <p className='text-center px-2 highlight quote'>
          <i>'{c.quote.text}'</i>
          <br />
          {c.quote.author}
        </p>

        <br />
        <br />

        <h2 className='text-center'>{c.sectionTitle}</h2>

        <div className='mt-1 mt-sm-3 m-3 m-lg-5 px-3 px-sm-4 px-md-5 bio'>
          {c.bioParagraphs.map((p, idx) => (
            <p key={idx}>{p}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
